import { motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';

export const MotionDivEnterExit: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <motion.div whileHover="enter" initial="exit" animate="exit" className={className}>
    {children}
  </motion.div>
);

export const MotionDivSlideInFromRight: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => (
  <motion.div initial={{ left: '100%' }} animate={{ left: '0' }} exit={{ left: '100%' }} className={className}>
    {children}
  </motion.div>
);

export const stihlMenuAnimate = {
  enter: {
    opacity: 1,
    translateY: 0,
    transition: {
      duration: 0.22,
      staggerChildren: 0.05,
    },
    display: 'block',
  },
  exit: {
    opacity: 0,
    translateY: '-5px',
    transition: {
      duration: 0.22,
    },
    transitionEnd: {
      display: 'none',
    },
  },
};

export const stihlMenuItemAnimate = {
  exit: { opacity: 0, translateY: '-5px' },
  enter: { opacity: 1, translateY: 0 },
};

export const subMenuAnimate = {
  enter: {
    opacity: 1,
    translateY: 0,
    transition: {
      duration: 0.22,
    },
    display: 'block',
  },
  exit: {
    opacity: 0,
    translateY: -10,
    transition: {
      duration: 0.22,
    },
    transitionEnd: {
      display: 'none',
    },
  },
};

export const subMenuItemsAnimate = {
  enter: {
    opacity: 1,
    translateY: 0,
    transition: {
      delay: 0.22,
      duration: 0.22,
      staggerChildren: 0.05,
    },
    display: 'block',
  },
  exit: {
    opacity: 0,
    translateY: -2,
    transition: {
      duration: 0.22,
    },
    transitionEnd: {
      display: 'none',
    },
  },
};

export const subMenuContainerAnimate = {
  enter: {
    opacity: 1,
    translateY: 0,
    transition: {
      duration: 0.22,
    },
    display: 'block',
  },
  exit: {
    opacity: 0,
    translateY: -2,
    transition: {
      delay: 0.22,
      duration: 0.22,
    },
    transitionEnd: {
      display: 'none',
    },
  },
};
